import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useRef } from 'react';
import useMonitorAPIService from '../../services/monitorapiservice';
import { SelectBox } from 'devextreme-react';
import Toastr from '../utils/toastr';

function AgentGroupsPriority(props) {

    const { t } = useTranslation();
    const toastrRef = useRef(null);

    const priorities = [{ value: -1, text: t('disabled') },
    { value: 1, text: t('minimum') },
    { value: 2, text: t('verylow') },
    { value: 3, text: t('low') },
    { value: 4, text: t('normal') },
    { value: 5, text: t('high') },
    { value: 6, text: t('veryhigh') },
    { value: 7, text: t('maximum') }];


    const { getUserGroups, changeUserGroupPriority } = useMonitorAPIService();


    const handlePriorityChange = (group, priority) => {
        let data = {
            group: group.grpId,
            priority: priority,
            pin: props.agent.userId
        }
        changeUserGroupPriority(props.token, data, (res) => {
            if (res.data) {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();
                props.setGroups(prevState =>
                    prevState.map(g =>
                        g.grpId === group.grpId ? { ...g, prioridad: priority } : g
                    )
                );
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            }
        });

    };
    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("user-group")} /> {t("agentgroups")}</span>

                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", "height": "300px", "overflow": "auto" }}>
                <Row>
                    <Col> <span className="fs-4 fw-bold text-primary my-2">{t("group")}</span></Col>
                    <Col> <span className="fs-4 fw-bold text-primary m-2">{t("priority")}</span></Col>
                </Row>

                {
                    props.groups.map(v => {
                        return (
                            <Row key={v.grpId}>
                                <Col> <span className="fs-5 fw-bold text-gray-800">{v.grupo}</span></Col>
                                <Col>
                                    <SelectBox className='m-1'
                                        dataSource={priorities}
                                        value={v.prioridad}
                                        onValueChange={e => { handlePriorityChange(v, e) }}
                                        disabled={!props.functions.changeUserPriority}
                                        valueExpr="value"
                                        displayExpr="text"
                                        dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                    />
                                </Col>
                            </Row>
                        )
                    })
                }
            </div>
            <Toastr ref={toastrRef} />
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        functions: state.supervisor.functions
    };
};

export default connect(mapStateToProps, {})(AgentGroupsPriority);